import k8Clusters from "public/kubernetes/kubernetes-cluster.png";

export const INTRO_CONSTANTS = {
  heading: "Custom-built clusters for your architecture. ",
  title: "Onemind's Private Kubernetes Clusters",
  description: [
    "With OneMind’s Managed Kubernetes Services, businesses gain access to a fully managed, enterprise-ready Kubernetes environment—without the complexity. We handle the operational heavy lifting, so teams can focus on building, shipping, and scaling applications. From workload orchestration to seamless integration with your CI/CD pipelines, everything is designed for efficiency, speed, and reliability.",
    "For organizations with stricter compliance or security requirements, we offer Private Kubernetes Clusters. These clusters operate entirely within a private network—no public access points—ensuring internal traffic stays secure and isolated. This setup offers all the flexibility of Kubernetes, with the control and privacy your infrastructure demands.",
    "Whether you’re running apps at the edge, in a hybrid cloud, or fully virtualized, OneMind makes Kubernetes work the way it should: scalable, secure, and fully managed.",
  ],
  points: [
    "Network-isolated clusters for enhanced security ",
    "Built-in auto-scaling and self-healing capabilities ",
    "Seamless integration with hybrid cloud environments ",
  ],
  image: k8Clusters,
  imageHeight: "460px",
};
